module.exports = __webpack_public_path__ + "img/russia.8e92376.webp";